<template>
  <div class="available-shifts">
    <BAccordion v-if="dayIsCurrent">
      <template v-for="aRota in availableShiftsByDayIndex" :key="aRota.id">
        <BAccordionItem v-if="aRota.shiftsByDayIndex[dayIndex]?.length > 0">
          <template #title>
            <span class="badge px-2 me-1">
              {{ aRota.shiftsByDayIndex[dayIndex]?.length || 0 }}
              <font-awesome-icon icon="hand" />
            </span>
            <span class="text-uppercase me-1 fw-bold">{{
              aRota.location
            }}</span>
            {{ aRota.type }} shifts available
          </template>

          <div
            v-for="shift in aRota.shiftsByDayIndex[dayIndex]"
            :id="`shift-${shift.id}`"
            :key="shift.id"
            class="shift"
          >
            <rota-shift-with-cover-request
              :rota-type="rota.type"
              :rota-status="rota.status"
              :rota-id="rota.id"
              :shift="shift"
              :activities="activities"
              @rota-shift-self-assign="$emit('rota-shift-self-assign', shift)"
            />
          </div>
        </BAccordionItem>
      </template>
    </BAccordion>
  </div>
</template>

<script>
import { computed } from "vue";
import { addDays, isToday, isFuture, setMilliseconds } from "date-fns";
import RotaShiftWithCoverRequest from "@/components/rota/shift/RotaShiftWithCoverRequest.vue";

import {
  formatDateAsDayWithSuffixShortMonth,
  formatTimeHoursMins,
  rotaDateIsToday,
} from "@/lib/date-functions";

export default {
  name: "RotaUserAgendaViewDayAvailableShifts",
  components: {
    RotaShiftWithCoverRequest,
  },
  props: {
    rota: {
      type: Object,
      default() {
        return {};
      },
    },
    dayIndex: {
      type: Number,
      default() {
        return 0;
      },
    },
    activities: {
      type: [Array, Boolean],
      default() {
        return false;
      },
    },
    availableShiftsByDayIndex: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ["rota-shift-self-assign"],
  setup(props) {
    const dayIsToday = computed(() => {
      const d = addDays(
        setMilliseconds(props.rota.startDate, 0),
        props.dayIndex,
      );
      return isToday(d);
    });

    return {
      dayIsCurrent: computed(() => {
        const d = addDays(
          setMilliseconds(props.rota.startDate, 0),
          props.dayIndex,
        );
        return isToday(d) || isFuture(d);
      }),
      dayIsToday,
      formatDateAsDayWithSuffixShortMonth,
      formatTimeHoursMins,
      rotaDateIsToday,
    };
  },
};
</script>

<style lang="scss">
.available-shifts {
  margin-bottom: 1em;
  .accordion-item {
    --bs-accordion-border-color: var(--cover-request-color);
    &:first-child {
      margin-top: 0.5em;
    }
  }
  .accordion-header {
    --bs-accordion-btn-color: var(--cover-request-color);
    span.badge {
      background-color: var(--cover-request-color);
    }
  }
  div.shift {
    border: 2px solid var(--cover-request-color) !important;
    margin-bottom: 1em !important;
  }
}
</style>
